var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',_vm._g(_vm._b({ref:"input",attrs:{"value":_vm.formattedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus,"keypress":_vm.onKeyPress,"paste":_vm.onPaste}},'b-form-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }